import { ProgramTypeNameEnum } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

export enum VendorName {
    WMG = 'WMG',
    UMG = 'UMG',
    AKM = 'AKM',
    OSA = 'OSA',
    SOLAR = 'SOLAR',
    UMPI = 'UMPI',
    WCM = 'WCM'
}

export enum Service {
    Unlimited = 'Unlimited',
    Prime = 'Prime',
    Free = 'Free'
}

export enum ServiceId {
    Unlimited = 1,
    Prime = 2,
    Free = 3
}

export const ALL_SERVICES = [Service.Unlimited, Service.Prime, Service.Free];

export enum Status {
    Active = 'Active',
    Ended = 'Ended',
    Upcoming = 'Upcoming',
    Canceled = 'Canceled',
    Draft = 'Draft'
}

export enum Territory {
    AU = 'AU',
    AT = 'AT',
    BR = 'BR',
    CA = 'CA',
    ES = 'ES',
    FR = 'FR',
    GB = 'GB',
    JP = 'JP',
    US = 'US',
    MX = 'MX'
}

export enum ServiceAbbr {
    AMU = 'AMU',
    PRIME = 'PRIME',
    AMF = 'AMF'
}

export enum RateCardStatus {
    Draft = 'Draft',
    Inactive = 'Inactive',
    Active = 'Active',
    Archived = 'Archived'
}

export enum Role {
    Viewer = 'Viewer',
    Editor = 'Editor',
    Writer = 'Writer',
    Admin = 'Admin',
    None = 'None',
    Maple = 'Maple',
    Tester = 'Tester',
    CAM = 'CAM'
}

export enum PaperPlanGroup {
    Standard = 'Standard',
    FreeTrial = 'Free Trial',
    ExtendedTrial = 'Extended Trial',
    PriceDrop = 'Price Drop',
    Employee = 'Employee',
    CarrierFreeTrial = 'Carrier Free Trial',
    CarrierIntro = 'Carrier Intro',
    CarrierStandard = 'Carrier Standard'
}

export enum PaperPlanRateGroup {
    Core = 'Core',
    NonMonthly = 'Non Monthly',
    FirstPartyPromo = '1P Promo',
    CarrierStandard = 'Carrier Standard',
    CarrierIntro = 'Carrier Intro',
    FreeTrial = 'Free Trial'
}

export enum PaperPlanPlanType {
    Individual = 'Individual',
    Family = 'Family',
    SingleDevice = 'Single Device',
    Student = 'Student'
}

export enum PaperPlanSubscriptionProduct {
    AlexaTier = 'Alexa Tier',
    CarrierBundle = 'Carrier Bundle',
    PaidHiRes = 'Paid HiRes',
    PaidPremiumTier = 'Paid Premium Tier',
    PaidSingleDeviceTier = 'Paid Single Device Tier',
    TrialHiRes = 'Trial HiRes',
    TrialPremiumTier = 'Trial Premium Tier',
    NA = 'N/A'
}

export enum PaperPlanCorePlan {
    IndM = 'Ind Monthly',
    HDIndM = 'HD Ind Monthly',
    FamM = 'Fam Monthly',
    HDFamM = 'HD Fam Monthly',
    ASDM = 'ASD Monthly',
    StudentM = 'Student Monthly',
    NinetyDayFT = 'FT Ind 90D',
    HDNinetyDayFT = 'FT HD Ind 90D',
    MontanaIndM = 'Montana Ind Monthly',
    MontanaFamM = 'Montana Fam Monthly',
    MontanaNinetyDayFT = 'Montana FT Ind 90D'
}

export enum CommentCategory {
    Deals = 'deals',
    Vendorcodes = 'vendorcodes',
    Paperplans = 'paperplans',
    Ratecards = 'ratecards'
}

export enum RateCardCoreRateGridColumnName {
    CheckBox = 'Checkbox',
    Territory = 'Territory',
    RatecardCurrency = 'Ratecard Currency',
    IndMonthlyPSM = 'Ind Monthly PSM',
    HDIndMonthlyPSM = 'HD Ind Monthly PSM',
    ASDMonthlyTier1PSM = 'ASD Monthly Tier 1 PSM',
    ASDMonthlyTier2PSM = 'ASD Monthly Tier 2 PSM',
    ASDMonthlyTier3PSM = 'ASD Monthly Tier 3 PSM',
    FamMonthlyPSM = 'Fam Monthly PSM',
    HDFamMonthlyPSM = 'HD Fam Monthly PSM',
    StudentMonthlyPSM = 'Student Monthly PSM',
    NinetyDayFTCPP = '90 Day FT CPP',
    HDNinetyDayFTCPP = 'HD 90 Day FT CPP',
    BlendedPSMFloor = 'Blended PSM Floor',
    SettlementCurrency = 'Settlement Currency',
    CAE = 'CAE',
    MontanaIndMonthlyPSM = 'Montana Ind Monthly PSM',
    MontanaFamMonthlyPSM = 'Montana Fam Monthly PSM',
    MontanaNinetyDayFTCPP = 'Montana 90 Day FT CPP'
}

export enum CorePlan {
    HAWKFIRE_ALL_DEVICES_MONTHLY = 'HAWKFIRE_ALL_DEVICES_MONTHLY',
    HAWKFIRE_KATANA_IND_MONTHLY = 'HAWKFIRE_KATANA_IND_MONTHLY',
    HAWKFIRE_HOME_ONLY_MONTHLY = 'HAWKFIRE_HOME_ONLY_MONTHLY',
    HAWKFIRE_FAMILY_MONTHLY = 'HAWKFIRE_FAMILY_MONTHLY',
    HAWKFIRE_KATANA_FAMILY_MONTHLY = 'HAWKFIRE_KATANA_FAMILY_MONTHLY',
    HAWKFIRE_STUDENT_MONTHLY = 'HAWKFIRE_STUDENT_MONTHLY',
    HAWKFIRE_ALL_DEVICES_90DAY_FREE_TRIAL = 'HAWKFIRE_ALL_DEVICES_90DAY_FREE_TRIAL',
    HAWKFIRE_KATANA_IND_MONTHLY_90_DAY_FT = 'HAWKFIRE_KATANA_IND_MONTHLY_90_DAY_FT',
    AMU_AB_ALL_DEVICES_MONTHLY = 'AMU_AB_ALL_DEVICES_MONTHLY',
    AMU_AB_ALL_DEVICES_90DAY_FREE_TRIAL = 'AMU_AB_ALL_DEVICES_90DAY_FREE_TRIAL',
    AMU_AB_FAMILY_MONTHLY = 'AMU_AB_FAMILY_MONTHLY'
}

export enum FreeTrialPlan {
    HAWKFIRE_ALL_DEVICES_90DAY_FREE_TRIAL = 'HAWKFIRE_ALL_DEVICES_90DAY_FREE_TRIAL',
    HAWKFIRE_KATANA_IND_MONTHLY_90_DAY_FT = 'HAWKFIRE_KATANA_IND_MONTHLY_90_DAY_FT',
    HAWKFIRE_FAMILY_90DAY_FREE_TRIAL = 'HAWKFIRE_FAMILY_90DAY_FREE_TRIAL',
    HAWKFIRE_KATANA_FAM_MONTHLY_90_DAY_FT = 'HAWKFIRE_KATANA_FAM_MONTHLY_90_DAY_FT',
    AMU_AB_ALL_DEVICES_90DAY_FREE_TRIAL = 'AMU_AB_ALL_DEVICES_90DAY_FREE_TRIAL',
    AMU_AB_FAMILY_90DAY_FREE_TRIAL = 'AMU_AB_FAMILY_90DAY_FREE_TRIAL'
}

export enum UmgPerfDiscountType {
    SubscriberVolume = 'Subscriber Volume',
    AllMusic = 'All Music',
    Churn = 'Churn',
    FreeTrialConversion = 'Free Trial Conversion'
}

export enum InputValidationRuleType {
    Required = 'Required',
    Max8Char = 'Max8Char',
    Greater0LessEqual1 = 'Greater0LessEqual1',
    GreaterEqual0LessEqual1 = 'GreaterEqual0LessEqual1',
    OneDecimal = 'OneDecimal',
    GreaterEqual1 = 'GreaterEqual1',
    GreaterEqualNegative1LessEqual1 = 'GreaterEqualNegative1LessEqual1',
    GreaterEqual1LessEqual99 = 'GreaterEqual1LessEqual99',
    FractionGreater0LessEqual1 = 'FractionGreater0LessEqual1'
}

export enum PlanWeightsTab {
    WMG = 'WMG',
    UMG = 'UMG',
    SONY = 'SONY',
    ORCHARD = 'ORCHARD',
    SONY_JP = 'SONY_JP'
}

export const ALL_WEIGHTS_TABS = [
    PlanWeightsTab.WMG,
    PlanWeightsTab.UMG,
    PlanWeightsTab.SONY,
    PlanWeightsTab.ORCHARD,
    PlanWeightsTab.SONY_JP
];

export enum ContractTermMultiplierKey {
    ANNUAL = 'annual',
    DAILY = 'daily',
    WEEKLY = 'weekly',
    PRICE_DROP_3M = 'priceDrop3m',
    PRICE_DROP_4M = 'priceDrop4m',
    PRICE_DROP_6M = 'priceDrop6m',
    WINBACK = 'winback',
    EXTENDED_TRIAL_2M = 'extendedTrial2m',
    EXTENDED_TRIAL_3M = 'extendedTrial3m',
    EXTENDED_TRIAL_4M = 'extendedTrial4m',
    EXTENDED_TRIAL_5M = 'extendedTrial5m',
    EXTENDED_TRIAL_6M = 'extendedTrial6m',
    ASD_EXTENDED_TRIAL_2M = 'asdExtendedTrial2m',
    ASD_EXTENDED_TRIAL_3M = 'asdExtendedTrial3m'
}

export enum RateMultiplierName {
    NONE = 'NONE',
    AUTO_CALC = 'AUTO_CALC'
}

export enum RateMultiplierDisplayName {
    NONE = 'No Multiplier',
    ANNUAL = 'Annual',
    DAILY = 'Daily',
    WEEKLY = 'Weekly',
    CUSTOM = 'Custom',
    PRICE_DROP_3M = '3m price drop',
    PRICE_DROP_4M = '4m price drop',
    PRICE_DROP_6M = '6m price drop',
    WINBACK = 'Winback',
    EXTENDED_TRIAL_2M = 'Extended trial 2m',
    EXTENDED_TRIAL_3M = 'Extended trial 3m',
    EXTENDED_TRIAL_4M = 'Extended trial 4m',
    EXTENDED_TRIAL_5M = 'Extended trial 5m',
    EXTENDED_TRIAL_6M = 'Extended trial 6m',
    ASD_EXTENDED_TRIAL_2M = 'ASD extended trial 2m',
    ASD_EXTENDED_TRIAL_3M = 'ASD extended trial 3m'
}

export enum AcknowledgedStatus {
    ACKNOWLEDGED = 'Reviewed',
    NOTACKNOWLEDGED = 'Pending Review'
}

export enum ContractBreadcrumbTitle {
    Contracts = 'Contracts',
    AddNewContract = 'Add new contract',
    EditContract = 'Edit contract',
    ViewContract = 'View contract'
}

export enum MultiplierName {
    ANNUAL = 'ANNUAL',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    PRICE_DROP_3M = 'PRICE_DROP_3M',
    PRICE_DROP_4M = 'PRICE_DROP_4M',
    PRICE_DROP_6M = 'PRICE_DROP_6M',
    WINBACK = 'WINBACK',
    EXTENDED_TRIAL_2M = 'EXTENDED_TRIAL_2M',
    EXTENDED_TRIAL_3M = 'EXTENDED_TRIAL_3M',
    EXTENDED_TRIAL_4M = 'EXTENDED_TRIAL_4M',
    EXTENDED_TRIAL_5M = 'EXTENDED_TRIAL_5M',
    EXTENDED_TRIAL_6M = 'EXTENDED_TRIAL_6M',
    ASD_EXTENDED_TRIAL_2M = 'ASD_EXTENDED_TRIAL_2M',
    ASD_EXTENDED_TRIAL_3M = 'ASD_EXTENDED_TRIAL_3M'
}

export enum BundlePricingSubAttribute {
    NON_PRIME = 'Non Prime',
    PRIME = 'Prime',
    IOS = 'iOS',
    GOOGLE = 'Android',
    NON_MUSIC = 'Non music'
}

export const ProgramTypeLabel = {
    [ProgramTypeNameEnum.DE_RADIO_PLAY]: 'DE radio play',
    [ProgramTypeNameEnum.HOUSEHOLD_SHARING_SIMULTANEOUS_PLAY]: 'Household sharing simultaneous play'
};
